import { Component, Input, OnInit } from '@angular/core';
import { Attending } from "../../../model/attending";
import { AttendingService } from "../../../service/attending.service"
import { InstallationPeriod } from "../../../constants/installation-period";
import { ToastService } from "../../../../shared/service/toast.service"
import { AttendingResponsabilityService } from "../../../../shared/service/attendiing-responsability.service";
import { MonitoringStepStatus } from "../../../constants/monitoring-step-status";
import { AttendingStatus } from '../../../constants/attending-status';
import { VehicleService } from '../../../../diagnosis/service/vehicle.service';
import { DiagnosisWebSocketService } from '../../../../diagnosis/service/diagnosis-web-socket.service';
import { DiagnosisType } from '../../../../shared/model/diagnosis-type';

@Component({
  selector: 'tx-monitoring-validation',
  templateUrl: './monitoring-validation.component.html',
  styleUrls: ['./monitoring-validation.component.css']
})

export class MonitoringValidationComponent implements OnInit {

  _attending: Attending;
  _modelFiles: Array<any>;
  _viewMode: boolean;
  _loading: boolean;

  files: Array<any>;
  vehicleParts: Map<string, string>;
  responsabilities: Array<any>;
  responsability: any;
  observation: string;
  vehicle: any;
  doDiagnosis: boolean;

  constructor(private _attendingService: AttendingService,
    private _toastService: ToastService,
    private _vehicleService: VehicleService,
    private _diagnosisNotification: DiagnosisWebSocketService,
    private _attendingResponsability: AttendingResponsabilityService) {

    this.getResponsabilities();
  }

  ngOnInit() {
    this._loading = false;
    this.doDiagnosis = false;
    this.setupObservers();
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this.handle();
    this.setEmptyEntities();
    this.findVehicleForDiagnosis();
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set viewMode(viewMode) {
    this._viewMode = viewMode;
  }

  get viewMode() {
    return this._viewMode;
  }

  @Input()
  set modelFiles(modelFiles) {
    this._modelFiles = modelFiles;
  }

  get modelFiles() {
    return this._modelFiles;
  }

  markAsAccepted(file) {
    file.accepted = file.accepted ? !file.accepted : true;
    this._attendingService.acceptInfoFile(file.id, file.accepted, this._attending.id).subscribe(
      response => file = response,
      error => this.showMessage(error.text)
    );
  }

  handleRejection(file) {
    file.accepted = false;
    this.removeFileFromMemoryList(file);
    this.deleteInfoFile(file);
    this.createUnsentParts(this.files);
  }

  showModelImage(file) {
  }

  canContinue() {
    return this.hasAcceptedAllFiles() && this.responsability != null && this._attending.attendingInfo.attendingStatus === AttendingStatus.WAITING_CENTRAL_VALIDATION;
  }

  submit() {
    let allFilesReachedBackEnd = this._attendingService.getCanContinueMonitoringWorkFlow(this.attending.id, InstallationPeriod.POST_INSTALLATION)
    if (allFilesReachedBackEnd) {
      let monitoringDto = {
        'id': this._attending.monitoring.id,
        'observation': this.observation, 'responsability': this.responsability
      };

      this._attendingService.setMonitoringValidationStep(monitoringDto)
        .subscribe(
          response => {
            this.showMessage('Monitoramento atualizado com sucesso!');
            this._attending.monitoring.validationStep = MonitoringStepStatus.FINISHED;
            this._attending.monitoring.conclusionStep = MonitoringStepStatus.CURRENT;
          },
          error => this.showMessage(error.text)
        );
    } else {
      this.showMessage("Ocorreu um erro durante a confirmação de um dos arquivos, por favor atualize a página!");
    }
  }

  getStatus() {
    if (this.hasAcceptedAllFiles()) {
      return 'Finalizado';
    }
    return 'Em atendimento';
  }

  private hasAcceptedAllFiles() {
    if (this.vehicleParts) {
      let filesToBeAccepted = this.getFilesToBeAcceptedSize();
      let filesAccepted = this.getAcceptedFilesSize();
      return filesAccepted >= filesToBeAccepted;
    }
    return false;
  }

  getResponsabilities() {
    this._attendingResponsability
      .getResponsabilities()
      .subscribe(
        responsabilities => this.responsabilities = responsabilities,
        error => this.showMessage(error.text)
      );
  }

  setResponsability(responsability) {
    this.responsability = responsability;
  }

  showEmptyState() {
    return !this._attending.diagnosisGeneralResults || this._attending.diagnosisGeneralResults.length === 0 && !this.doDiagnosis;
  }

  showRequiredJustification() {
    return this.getPreviousDiagnosis() !== undefined && !this.getPreviousDiagnosis().approved;
  }

  startDiagnosis() {
    this.doDiagnosis = true;
  }

  canStartDiagnosis() {
    return this.vehicle != null;
  }

  hasDiagnosis() {
    return this._attending.diagnosisGeneralResults && this._attending.diagnosisGeneralResults.length > 0;
  }

  getPreviousDiagnosis() {
    if (this.hasDiagnosis()) {
      return this._attending.diagnosisGeneralResults[0];
    }
    return undefined;
  }

  findVehicleForDiagnosis() {
    if (!this._diagnosisNotification.getCustomer()) {
      this._diagnosisNotification.setCustomer(this.attending.branch.customer);
    }
    if (!this.vehicle) {
      this._vehicleService.getVehiclesByUser(this.attending.branch.customer.trixUser.id, DiagnosisType.GENERAL);
    }
  }

  private handle() {
    this._attendingService
      .getVehicleParts(this._attending.id, InstallationPeriod.POST_INSTALLATION)
      .subscribe(
        response => {
          this.vehicleParts = response;
          this.handleFiles();
        },
        error => this.showMessage(error.text)
      );
  }

  private handleFiles() {
    this.files = new Array();
    if (this.attending.attendingInfo.files && this.attending.attendingInfo.files.length > 0) {
      this.handleExistingFiles();
    } else {
      this.simpleCreateEmptyFiles(this.vehicleParts);
    }
  }

  private handleExistingFiles() {
    this.setFiles();
    this.createUnsentParts(this._attending.attendingInfo.files);
  }

  private createUnsentParts(files) {
    let unsentParts = this.getUnsentVehicleParts(files);
    if (unsentParts.length > 0) {
      this.createEmptyFiles(this.vehicleParts, unsentParts);
    }
  }

  private getUnsentVehicleParts(files) {
    let partsToCreate = new Array();
    for (let key in this.vehicleParts) {
      let mustCreate = true;
      files.forEach((value) => {
        if (value.vehiclePart === key) {
          mustCreate = false;
        }
      });

      if (mustCreate) {
        partsToCreate.push(key);
      }
    }
    return partsToCreate;
  }

  private setFiles() {
    this.attending.attendingInfo.files.forEach((value) => {
      if (value.period === InstallationPeriod.POST_INSTALLATION) {
        this.files.push(value);
      }
    });
  }

  private createEmptyFiles(vehicleParts, keysToCreate) {
    for (let key in vehicleParts) {
      if (keysToCreate.includes(key)) {
        this.files.push({
          description: vehicleParts[key],
          vehiclePart: key,
          accepted: false,
          period: InstallationPeriod.POST_INSTALLATION
        });
      }
    }
  }

  private simpleCreateEmptyFiles(vehicleParts) {
    for (let key in vehicleParts) {
      this.files.push({
        description: vehicleParts[key],
        vehiclePart: key,
        accepted: false,
        period: InstallationPeriod.POST_INSTALLATION
      });
    }
  }

  private getAcceptedFilesSize() {
    let size = 0;
    this.files.forEach((value) => {
      if (value.accepted) {
        size = size + 1;
      }
    });
    return size;
  }

  private getFilesToBeAcceptedSize() {
    let size = 0;
    for (let key in this.vehicleParts) {
      size = 1 + size;
    }
    return size;
  }

  private removeFileFromMemoryList(file) {
    let fileIndex = this.files.indexOf(file);
    this.files.splice(fileIndex, 1);
  }

  private deleteInfoFile(file) {
    this._attendingService.deleteInfoFile(file.id, this._attending.id).subscribe(
      response => {
        this.showMessage('Arquivo removido com sucesso!')
      },
      error => this.showMessage(error.text)
    );
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

  private setEmptyEntities() {
    if (this._attending.monitoring.attendingResponsibility != null) {
      this.responsability = this._attending.monitoring.attendingResponsibility;
    }

    if (this._attending.monitoring.observation != null) {
      this.observation = this._attending.monitoring.observation;
    }
  }

  private setupObservers() {
    this._vehicleService.find$
      .subscribe(vehicles => {
        this.vehicle = vehicles.find(vehicle => vehicle.plate === this._attending.vehiclePlate);
        if (this.vehicle !== undefined) {
          this.vehicle.attendingId = this._attending.id;
          this.vehicle.diagnosisType = DiagnosisType.GENERAL;
          this.vehicle.coordinateStartDate = this._attending.attendingInfo.startedDate;
        }
      });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/monitoring-validation/monitoring-validation.component.ts